// AUTO-GENERATED - DO NOT EDIT MANUALLY

import { BookingEventActionType } from './enums.gen';
import { hydrateEmailAction, type EmailAction, type EmailActionApiResponse } from './emailAction.gen';
import { hydrateSmsAction, type SmsAction, type SmsActionApiResponse } from './smsAction.gen';
import { hydrateWebhookAction, type WebhookAction, type WebhookActionApiResponse } from './webhookAction.gen';

export type BookingEventActionApiResponse = EmailActionApiResponse | SmsActionApiResponse | WebhookActionApiResponse;
export type BookingEventAction = EmailAction | SmsAction | WebhookAction;

export function hydrateBookingEventAction(data: BookingEventActionApiResponse): BookingEventAction {
	switch (data.type) {
		case BookingEventActionType.Email:
			return hydrateEmailAction(data as EmailActionApiResponse);
		case BookingEventActionType.Sms:
			return hydrateSmsAction(data as SmsActionApiResponse);
		case BookingEventActionType.Webhook:
			return hydrateWebhookAction(data as WebhookActionApiResponse);
	}
}